import { useMutation } from '@apollo/client';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router';
import { useAppDispatch } from '../app/redux/useAppSelector';
import { gql } from '../graphql/generated/gql';
import { PostType } from '../graphql/generated/graphql';
import { UIActions } from '../ui/uiSlice';
import useNavigate from '../utils/router/useNavigate';
import postPath from '../utils/url/postPath';

const CREATE_POST_MUTATION = gql(/** @complexity 2 */ `
  mutation createPost(
    $topicId: ID
    $libraryName: String
    $type: PostType
    $templateId: ID
  ) {
    post: createPost(
      topicId: $topicId
      libraryName: $libraryName
      type: $type
      templateId: $templateId
    ) {
      id
      shareSecret
      ...postPath_post
    }
  }
`);

const CreatePostView = () => {
  const [searchParams] = useSearchParams();
  const templateId = searchParams.get('templateId');
  const library = searchParams.get('library');
  const topicId = searchParams.get('topicId');
  const type = searchParams.get('type');

  const [createPost] = useMutation(CREATE_POST_MUTATION, {
    variables: {
      topicId,
      libraryName: library,
      type: type === 'template' ? PostType.Template : PostType.Post,
      templateId,
    },
  });

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    createPost().then(({ data }) => {
      if (data?.post) {
        if (templateId) {
          dispatch(UIActions.addUsedTemplate(templateId));
        }

        navigate(
          postPath(data.post, {
            shareSecret: data.post.shareSecret ?? undefined,
          }),
          {
            replace: true,
          },
        );
      }
    });
  }, [createPost, dispatch, navigate, templateId]);

  return null;
};

export default CreatePostView;
